import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * Respuesta del tab Extra Servicios (detalle liquidación agencia) vía
 * dbo.sp_DetalleLiqAgenciaExtraServicios (2 recordsets: filas + totales).
 */
export class LiquidacionAgenciaExtraServiciosTabDto {
  @ApiProperty({
    description: 'Orden de columnas (cabecera)',
    type: [String],
    example: [
      'Exportador',
      'NroOS',
      'RefCliente',
      'Servicio',
      'TipoFacturacion',
      'Cantidad',
      'TotalVentaNeto',
      'TotalTraspasoBruto',
      'GestionOPBNeto',
    ],
  })
  columns!: string[];

  @ApiProperty({
    description: 'Filas de órdenes de servicio (TypeOfShipmentId IS NULL)',
    type: 'array',
    items: { type: 'object', additionalProperties: true },
  })
  rows!: Record<string, string | number | null>[];

  @ApiPropertyOptional({
    description: 'Fila de totales (segundo recordset)',
    type: 'object',
    additionalProperties: true,
  })
  totalsRow!: Record<string, string | number | null> | null;

  @ApiProperty({
    description: 'Cantidad de filas de detalle (sin totales)',
    example: 5,
  })
  totalFilas!: number;
}
